import {
  CONFIGURATION_COMBINATION_TYPES,
  CONFIGURATION_DEVICE_TYPES,
  CONFIGURATION_TEST_TYPES,
} from '../../constants';

const {
  APP_REAL_DEVICE,
  APP_VIRTUAL_DEVICE,
  WEB_DESKTOP_BROWSER,
  WEB_REAL_DEVICE,
  WEB_VIRTUAL_DEVICE,
} = CONFIGURATION_COMBINATION_TYPES;

const VDC_WEB_SCHEMA = {
  type: 'object',
  properties: {
    deviceType: { const: CONFIGURATION_DEVICE_TYPES.DESKTOP_BROWSER },
    testType: { const: CONFIGURATION_TEST_TYPES.WEB },
    tunnel: { type: 'string', nullable: true },
    url: { type: 'string' },
    browserConfiguration: {
      type: 'object',
      properties: {
        browser: { type: 'string' },
        browserDisplay: { type: 'string' },
        browserVersionDisplay: { type: 'string' },
        device: { type: 'string' },
        os: { type: 'string' },
        osDisplay: { type: 'string' },
        osVersionDisplay: { type: 'string' },
        res: { type: 'string' },
        version: { type: 'string' },
      },
      required: ['browser', 'browserDisplay', 'browserVersionDisplay', 'device', 'os', 'osDisplay', 'osVersionDisplay', 'res', 'version'],
    },
  },
  required: ['deviceType', 'testType', 'tunnel', 'url', 'browserConfiguration'],
};

const VMD_WEB_SCHEMA = {
  type: 'object',
  properties: {
    deviceType: { const: CONFIGURATION_DEVICE_TYPES.VIRTUAL_DEVICE },
    testType: { const: CONFIGURATION_TEST_TYPES.WEB },
    tunnel: { type: 'string', nullable: true },
    url: { type: 'string' },
    virtualDeviceConfiguration: {
      type: 'object',
      properties: {
        browser: { type: 'string' },
        browserDisplay: { type: 'string' },
        browserVersionDisplay: { type: 'string' },
        device: { type: 'string' },
        os: { type: 'string' },
        osDisplay: { type: 'string' },
        osVersionDisplay: { type: 'string' },
        res: { type: 'string', nullable: true },
        version: { type: 'string' },
      },
      required: ['browser', 'browserDisplay', 'browserVersionDisplay', 'device', 'os', 'osDisplay', 'osVersionDisplay', 'res', 'version'],
    },
  },
  required: ['deviceType', 'testType', 'tunnel', 'url', 'virtualDeviceConfiguration'],
};

const VMD_APP_SCHEMA = {
  type: 'object',
  properties: {
    app: { type: 'string', pattern: '^storage:' },
    deviceType: { const: CONFIGURATION_DEVICE_TYPES.VIRTUAL_DEVICE },
    testType: { const: CONFIGURATION_TEST_TYPES.APP },
    tunnel: { type: 'string', nullable: true },
    virtualDeviceConfiguration: {
      type: 'object',
      properties: {
        browser: { type: 'string' },
        browserDisplay: { type: 'string' },
        browserVersionDisplay: { type: 'string' },
        device: { type: 'string' },
        os: { type: 'string' },
        osDisplay: { type: 'string' },
        osVersionDisplay: { type: 'string' },
        res: { type: 'string', nullable: true },
        version: { type: 'string' },
      },
      required: ['browser', 'browserDisplay', 'browserVersionDisplay', 'device', 'os', 'osDisplay', 'osVersionDisplay', 'res', 'version'],
    },
  },
  required: ['app', 'deviceType', 'testType', 'tunnel', 'virtualDeviceConfiguration'],
};

const RDC_WEB_SCHEMA = {
  type: 'object',
  properties: {
    deviceType: { const: CONFIGURATION_DEVICE_TYPES.REAL_DEVICE },
    testType: { const: CONFIGURATION_TEST_TYPES.WEB },
    tunnel: { type: 'string', nullable: true },
    url: { type: 'string' },
    realDeviceConfiguration: {
      type: 'object',
      properties: {
        // KISS: for now we don't need more than this
        // although the deviceDescriptor contains a lot more information
        dataCenterId: { type: 'string' },
        descriptorId: { type: 'string' },
      },
      required: ['dataCenterId', 'descriptorId'],
    },
  },
  required: ['deviceType', 'testType', 'tunnel', 'url', 'realDeviceConfiguration'],
};

const RDC_APP_SCHEMA = {
  type: 'object',
  properties: {
    app: { type: 'string', pattern: '^storage:' },
    deviceType: { const: CONFIGURATION_DEVICE_TYPES.REAL_DEVICE },
    testType: { const: CONFIGURATION_TEST_TYPES.APP },
    tunnel: { type: 'string', nullable: true },
    realDeviceConfiguration: {
      type: 'object',
      properties: {
        // KISS: for now we don't need more than this
        // although the deviceDescriptor contains a lot more information
        dataCenterId: { type: 'string' },
        descriptorId: { type: 'string' },
      },
      required: ['dataCenterId', 'descriptorId'],
    },
  },
  required: ['app', 'deviceType', 'testType', 'tunnel', 'realDeviceConfiguration'],
};

export default {
  [APP_VIRTUAL_DEVICE]: VMD_APP_SCHEMA,
  [APP_REAL_DEVICE]: RDC_APP_SCHEMA,
  [WEB_DESKTOP_BROWSER]: VDC_WEB_SCHEMA,
  [WEB_REAL_DEVICE]: RDC_WEB_SCHEMA,
  [WEB_VIRTUAL_DEVICE]: VMD_WEB_SCHEMA,
};
